import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

type ErrorMessageProps = {
  errorCode: number;
};

const ErrorMessage = ({ errorCode }: ErrorMessageProps) => {
  if (errorCode !== 410) {
    return null;
  }

  return (
    <Typography color="info" align="center">
      <FormattedMessage
        id="subscriptionPage.deletedAccount"
        values={{
          strong: chunks => <strong>{chunks}</strong>,
        }}
      />
    </Typography>
  );
};

export default ErrorMessage;
